<div class="custom-select-container">
  <select [value]="value" (change)="onSelect($event)" (blur)="onTouched()" [disabled]="isDisabled">
    @for (option of options; track option) {
      <option [value]="option">{{ option }}</option>
    }
  </select>
</div>
